import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { NavLink } from 'react-router-dom';
import classnames from 'classnames';

import hashTagCampaigns from 'assets/data/hashTagCampaigns.json';
import Styles from 'views/pages/GanheMaisGlampoints.module.scss';

import { UiActions } from 'state/actions/UiActions';

import { CopyIcon } from 'components/icons/Copy';
import { DownloadIcon } from 'components/icons/Download';

class GanheMaisGlampoints extends Component {
  constructor(props) {
    super(props);

    this.copyToClipBoard = this.copyToClipBoard.bind(this);
    this._renderImagesList = this._renderImagesList.bind(this);
    this.forDownload = this.forDownload.bind(this);
  }

  copyToClipBoard = (id) => {
    return (event) => {
      event.preventDefault();
      let valToCopy = document.getElementById(id).innerText;
      let textarea = document.createElement('textarea');

      textarea.innerText = valToCopy;
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      document.execCommand('copy');
      textarea.remove();

      this.props.publishSuccessAlert('Copiado com sucesso!');
    };
  };

  _renderImagesList = (itemFROM) => {
    if (itemFROM.length > 1) {
      return itemFROM.map((name, key) => {
        return <img key={key} src={name} alt={''} />;
      });
    } else {
      return <img src={itemFROM} alt={''} />;
    }
  };

  forDownload = (str) => {
    if (str.forDownload) {
      return (
        <div className={Styles['down']}>
          <span className={Styles['label']}>Baixar</span>
          <a href={str.imagem} target={'_blank'} download={true} title={'Baixar a imagem'}>
            <DownloadIcon fill={'#fff'} />
          </a>
        </div>
      );
    }
  };

  _renderEditionImagesList = () => {
    return hashTagCampaigns.brands.map((item, key) => {
      return (
        <div key={key} className={classnames(Styles['brand'], 'level-3')}>
          <div className={Styles['header']}>
            <h3>{item.title}</h3>
            <p dangerouslySetInnerHTML={{ __html: item.description }} />
            {item.glampoints && <span>{item.glampoints}</span>}
          </div>
          <div className={Styles['images']}>{this._renderImagesList(item.imagem)}</div>
          <div className={Styles['footer']}>
            {this.forDownload(item)}
            <div className={Styles['hash']}>
              <span className={Styles['label']}>Copiar hashtag</span>
              <div className={Styles['hashField']}>
                <span id={'hashtag' + key}>{item.hashtag}</span>
                <button onClick={this.copyToClipBoard('hashtag' + key)} title={'Copiar hashtag!'}>
                  <CopyIcon fill={'#fff'} />
                </button>
              </div>
            </div>
            <small>Copie a hashtag clicando no botão com o símbolo de copiar.</small>
          </div>
        </div>
      );
    });
  };

  render() {
    return (
      <div className={'p-2 p-lg-5'}>
        <Helmet>
          <title>Minha Glambox : Campanhas #Hashtag</title>
        </Helmet>

        <h1>Campanhas #Hashtag</h1>

        <div className={Styles['promoGlampoints']}>
          <div className={Styles['text']}>
            <img
              src="	https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_21000.png"
              alt="logo"
            />
            <p>
              As 10 Glamgirls que mais acumularem Glampoints esse mês levam esse prêmio, participe
              das campanhas de hashtag abaixo e garanta seus pontos!
              <div className={Styles['link-insta']}>
                Antes de tudo, conecte sua conta do Instagram,
                <a href="https://minha.glambox.com.br/dados-pessoais"> clique aqui.</a>
              </div>
            </p>
          </div>
        </div>

        <div id={Styles['regras']}>
          <h2>Regras:</h2>
          <div className={Styles['block']}>
            <p className={Styles['text']}>
              As pontuações só serão creditadas por postagens realizadas no feed / IGTV em perfis
              pessoais e abertos ao público. Contamos com sua personalidade para compartilhar nossas
              marcas e se desenvolver como influenciadora na sua comunidade.
            </p>
          </div>
          <div className={Styles['block']}>
            <p className={Styles['text']}>
              Usar a hashtag correta. Por isso, confirme o nome certinho antes da postagem.
            </p>
          </div>
          <div className={Styles['block']}>
            <p className={Styles['text']}>
              Marcar o perfil @glamboxbrasil na sua postagem. Só assim localizaremos sua postagem.
            </p>
          </div>
        </div>

        <h2>Campanhas Ativas</h2>

        {/* ITEM DE HASHTAG */}
        <div id={Styles['brandsHashtags']}>{this._renderEditionImagesList()}</div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  person: state.person.data,
  token: state.token.data,
});

const mapDispatchToProps = (dispatch) => ({
  publishSuccessAlert: (message) => {
    dispatch(UiActions.publishSuccessAlert(message));
  },
});

GanheMaisGlampoints = connect(mapStateToProps, mapDispatchToProps)(GanheMaisGlampoints);

export { GanheMaisGlampoints };
